<script setup>
import PictureLazy from '@maison/components/common/PictureLazy.vue';
import { PhxsgButton } from '@sg/src/View/Components/Atoms/Button';

defineProps({
  reference: {
    type: String,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
  image: {
    type: Object,
    required: true,
  },
  price: {
    type: String,
    required: true,
  },
  size: {
    type: String,
    default: null,
  },
  editable: {
    type: Boolean,
    default: false,
  },
  removable: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['removeProduct', 'editProduct']);
</script>

<template>
  <article class="strap-finder-summary-card">
    <div class="picture strap-finder-summary-card__media theme-grey-95">
      <picture-lazy v-bind="image" />
    </div>

    <div class="strap-finder-summary-card__content stack stack--spacing-1">
      <h4 class="heading-small strap-finder-summary-card__title">{{ name }}</h4>
      <p class="heading-small">{{ price }}</p>
      <p v-if="size" class="text-muted">
        {{ $t('ProductFinderConfigurator.product.size', { size: size }) }}
      </p>

      <div v-if="removable || editable" class="strap-finder-summary-card__actions mt-2">
        <PhxsgButton
          v-if="editable"
          variant="fade"
          class="summary-card__action"
          @click="$emit('editProduct', reference)"
        >
          {{ $t('StrapFinderConfigurator.product.actions.edit') }}
        </PhxsgButton>
        <hr v-if="removable && editable" class="divider divider--spacing-2 divider--vertical" />
        <PhxsgButton
          v-if="removable"
          variant="fade"
          class="summary-card__action"
          @click="$emit('removeProduct', reference)"
        >
          {{ $t('StrapFinderConfigurator.product.actions.remove') }}
        </PhxsgButton>
      </div>
    </div>
  </article>
</template>
